import React, { useContext, useEffect } from 'react';
import { Context as AuthContext } from 'contexts/auth';
import { Config } from 'configs';
import { useAggregate } from 'hooks';
import { Loader } from 'components/indicators/loader';
import { RestaurantsDeliverySingle } from './_delivery_single';

export const RestaurantsAddEditFormDelivery = ({ itemData }) => {
  const { state: auth } = useContext(AuthContext);

  const getDeliveryRestaurantsRequest = {
    collectionName: Config.DATA.COLLECTIONS.WEB_USERS,
    aggregateId: Config.DATA.AGGREGATES.GET_DELIVERY_RESTAURANTS,
    secretKey: auth.token,
    filterBuilder: () => {
      const filter = {
        company: auth.company?.company,
        restaurantId: itemData._id,
      };

      return filter;
    },
    loadOnInit: false,
    dontRunOnInit: true,
    aggregateIdV2: 'AdminGetDeliveryRestaurant',
    companyIdForV2: auth.company?.company,
  };

  const [findDeliveryRestaurants, deliveryRestaurants, isLoadingDeliveryRestaurants] = useAggregate(
    getDeliveryRestaurantsRequest,
  );

  useEffect(() => {
    if (itemData) {
      findDeliveryRestaurants();
    }
  }, []);

  return (
    <>

      <div className="shadow sm:rounded-md sm:overflow-hidden">
        <div className="bg-white py-6 px-4 space-y-6 sm:p-6">

          <div className="flex flex-row flex-wrap justify-between items-center">
            <div>
              <h3 className="text-lg leading-6 font-medium text-gray-900">Delivery / Takeout settings</h3>
              {!isLoadingDeliveryRestaurants && (!deliveryRestaurants || deliveryRestaurants.length === 0) && (
              <p className="mt-6 text-sm text-gray-700">
                Deliveries not enabled
              </p>
              )}
            </div>
          </div>
        </div>
      </div>

      {!!isLoadingDeliveryRestaurants && <div className="mt-6"><Loader small /></div>}

      {!isLoadingDeliveryRestaurants && deliveryRestaurants && deliveryRestaurants.length > 0 && (
        deliveryRestaurants.map((x) => {
          return (
            <div className="mt-6" key={x._id}>
              <RestaurantsDeliverySingle itemData={x} />
            </div>
          );
        })
      )}
    </>
  );
};
